import React, { useEffect } from 'react';
import ApexCharts from 'apexcharts';
import { chartOptions } from '../consts';

export function PostsGraph({ data }) {
	const id = 'posts-graph';

	useEffect(() => {
		const element = document.getElementById(id);

		if (!element || !data || !data.length) {
			return;
		}
		const options = getChartOption(data);
		const chart = new ApexCharts(element, options);
		chart.render();

		return function cleanUp() {
			chart.destroy();
		};
	}, [data]);

	return <div id={id}></div>;
}

function getChartOption(data) {
	const postsData = data.map((d) => {
		return {
			...d.metrics.Posts, ts: d.ts
		}
	})
	const preOptions = chartOptions(postsData);
	preOptions.yaxis = {
		...preOptions.yaxis,
		labels: {
			formatter: (v) => parseInt(v),
		},
	};
	if (!postsData || !postsData.length) {
		return;
	}

	const options = {
		series: [
			{
				name: 'Photos',
				data: postsData.map((d) => d.galleryPost || 0),
			},
			{
				name: 'Videos',
				data: postsData.map((d) => d.videoPost || 0),
			},
			{
				name: 'Outfits',
				data: postsData.map((d) => d.outfitPost || 0),
			},
			{
				name: 'Polls',
				data: postsData.map((d) => d.pollPost || 0),
			},
			{
				name: 'Questions',
				data: postsData.map((d) => d.questionPost || 0),
			},
		],
		colors: ['#17C5BD', '#D55DB1', '#835FC2', '#FE6F5E', '#FFC75F'],
		...preOptions,
	};
	return options;
}
